import { defineMessages } from "react-intl";

export default defineMessages({
  emptyProjectCatalog: {
    id: "components.mapping.projectCatalogTree.emptyProjectCatalog",
    defaultMessage: "Empty project catalog"
  }
});
